module.exports = __webpack_public_path__ + "static/media/logo-internal-retina.2fbb6b15.png";